<div class="splash-screen" [class.fade-out]="_fadeOut">
  <div class="splash-content">
    <div class="logo-container">
      <ddc-logo
        class="daydic-logo daydic-logo-desktop"
        routerLinkActive="router-link-active"
        [hasText]="true"
        [size]="'medium'"
      ></ddc-logo>
    </div>

    <div class="loading-steps">
      @for (step of _steps; track step.label) {
        <div class="step" [class.completed]="step.completed">
          <div class="step-icon">
            @if (step.completed) {
              <svg class="checkmark" fill="none" viewBox="0 0 24 24">
                <path
                  d="M5 13l4 4L19 7"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                />
              </svg>
            } @else {
              <div class="spinner"></div>
            }
          </div>
          <span class="step-label">{{ step.label }}</span>
        </div>
      }
    </div>
  </div>
</div>
